import React from 'react';

import './steps-redeem-item.scss';

const StepsRedeemItem = props => {

  const { imgUrl, index, description } = props;

  return (
    <div className="f-steps-item">
      <div className="f-steps-item-image">
        <div className="f-steps-item-image-container">
          <span className="f-steps-item-image-container-number">
            <p>{index}</p>
          </span>
          <img src={imgUrl} alt='' />
        </div>
      </div>
      <div className="f-steps-item-info">
        {description}
      </div>
    </div>
  )
}

export default StepsRedeemItem;
